function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import convert from 'color-convert';
import clamp from 'lodash.clamp';
/**
 * Darken the provided colour
 * @param color Color in hex format to convert (with #)
 * @param depth Depth to convert the color to
 * @param maxDepth Maximum depth. Defaults to 6
 * @returns Darkened colour in hex format
 */
export function darkenForDepth(color, depth) {
  var maxDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  var lab = convert.hex.lab.raw(color);

  // determined via a trial an error approach to getting
  // something that works for both light and dark
  var modifier = lab[0] < 50 ? 17 : 10;
  lab[0] = Math.max(lab[0] - modifier / maxDepth * depth, 0);
  return "#".concat(convert.lab.hex(lab));
}

/**
 * Convert a hex colour to an rgba with specified alpha
 * @param color Color in hex format to convert (with #)
 * @param alpha Alpha to apply to the color
 * @returns Color with the newly applied alpha in rgba format
 */
export function colorWithAlpha(color, alpha) {
  var _convert$hex$rgb = convert.hex.rgb(color),
    _convert$hex$rgb2 = _slicedToArray(_convert$hex$rgb, 3),
    r = _convert$hex$rgb2[0],
    g = _convert$hex$rgb2[1],
    b = _convert$hex$rgb2[2];
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
}

/**
 * Converts a color in RGB to Oklab
 * Formula provided here: https://bottosson.github.io/posts/oklab/#converting-from-linear-srgb-to-oklab
 * @param color An RGB color
 * @returns The color but respresented as an Oklab color
 */
var linearSRGBToOklab = color => {
  var r = color.r,
    g = color.g,
    b = color.b;
  var l = 0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b;
  var m = 0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b;
  var s = 0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b;
  var l2 = Math.cbrt(l);
  var m2 = Math.cbrt(m);
  var s2 = Math.cbrt(s);
  return {
    L: 0.2104542553 * l2 + 0.793617785 * m2 - 0.0040720468 * s2,
    a: 1.9779984951 * l2 - 2.428592205 * m2 + 0.4505937099 * s2,
    b: 0.0259040371 * l2 + 0.7827717662 * m2 - 0.808675766 * s2
  };
};

/**
 * Converts an Oklab color to RGB
 * Formula provided here: https://bottosson.github.io/posts/oklab/#converting-from-linear-srgb-to-oklab
 * @param color An Oklab color
 * @returns The given color but represented as a RGB color
 */
var OklabToLinearSRGB = color => {
  var L = color.L,
    a = color.a,
    b = color.b;
  var l2 = L + 0.3963377774 * a + 0.2158037573 * b;
  var m2 = L - 0.1055613458 * a - 0.0638541728 * b;
  var s2 = L - 0.0894841775 * a - 1.291485548 * b;
  var l = l2 * l2 * l2;
  var m = m2 * m2 * m2;
  var s = s2 * s2 * s2;
  return {
    r: clamp(+4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s, 0, 255),
    g: clamp(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s, 0, 255),
    b: clamp(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s, 0, 255)
  };
};

/**
 * Converts a hex color to RGB
 * Algorithm from https://stackoverflow.com/a/39077686/20005358
 * @param hex A hex color
 * @returns The RGB representation of the given color
 */
var hexToRgb = hex => {
  var _hex$replace$substrin, _hex$replace$substrin2;
  var rgbArray = (_hex$replace$substrin = (_hex$replace$substrin2 = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#".concat(r).concat(r).concat(g).concat(g).concat(b).concat(b)).substring(1).match(/.{2}/g)) === null || _hex$replace$substrin2 === void 0 ? void 0 : _hex$replace$substrin2.map(x => parseInt(x, 16))) !== null && _hex$replace$substrin !== void 0 ? _hex$replace$substrin : [0, 0, 0];
  return {
    r: rgbArray[0],
    g: rgbArray[1],
    b: rgbArray[2]
  };
};

/**
 * Converts a RGB color to hex
 * Algorithm from https://stackoverflow.com/a/39077686/20005358
 * @param color A RGB color
 * @returns The hexcode of the given color
 */
var rgbToHex = color => {
  var r = Math.round(color.r);
  var g = Math.round(color.g);
  var b = Math.round(color.b);
  return "#".concat([r, g, b].map(x => {
    var hex = x.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }).join(''));
};

/**
 * Calculates a color given an interpolation factor between two given colors
 * @param color1 Color on one end
 * @param color2 Color on other end
 * @param factor The interpolation factor (0 to 1, 0 will be color1 while 1 will be color2)
 * @returns The color determined by the interpolation factor between the two colors
 */
var lerpColor = (color1, color2, factor) => {
  var L1 = color1.L,
    a1 = color1.a,
    b1 = color1.b;
  var L2 = color2.L,
    a2 = color2.a,
    b2 = color2.b;
  var L = L1 + (L2 - L1) * factor;
  var a = a1 + (a2 - a1) * factor;
  var b = b1 + (b2 - b1) * factor;
  return {
    L,
    a,
    b
  };
};
export default {
  colorWithAlpha,
  darkenForDepth,
  linearSRGBToOklab,
  OklabToLinearSRGB,
  hexToRgb,
  rgbToHex,
  lerpColor
};
//# sourceMappingURL=GridColorUtils.js.map